import { useTransAppProductName } from 'hooks/useTrans';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { useTranslate } from '@tolgee/react';
import { fromInfo } from './styles';
import { useMessageFooterQAPairBtnInfo } from 'hooks/business/im/useMessageFooterQAPairBtnInfo';

import { MessageExtendFooterProps } from './types';
import { QAPairButton } from './QAPairButton';
import { useQAPairTriggerFromAssistant } from 'hooks/business/im/useQAPairTrigger';
import { useModifyOnChat } from '@knowledge/knowledges/SupplementKnowledge/ModifyOnChat/useModifyOnChat';

type AssistantFooterProps = Pick<MessageExtendFooterProps, 'raw' | 'conversation'> & {
  isGalaxy: boolean;
};

const OfficialFooter = (props: AssistantFooterProps) => {
  const { raw, conversation } = props;
  const { isAutoReply } = raw;
  const { channel } = conversation;
  const { t } = useTranslate();

  const platform = platformLabelMap[toLowerCase(channel)];

  if (isAutoReply) {
    return (
      <div className={fromInfo}>
        {t('ViewsChat.此消息来自platform卖家中心(自动)', { platform })}
      </div>
    );
  }

  return <div className={fromInfo}>{t('ViewsChat.此消息来自platform卖家中心', { platform })}</div>;
};

const DefaultFooter = (props: AssistantFooterProps & { extraNode?: JSX.Element }) => {
  const { raw, conversation, extraNode = null } = props;
  const qaPairBtnInfo = useMessageFooterQAPairBtnInfo(raw);
  const trigger = useQAPairTriggerFromAssistant();
  const { show: showModifyOnChat } = useModifyOnChat();

  if (qaPairBtnInfo && qaPairBtnInfo.enable) {
    return (
      <div className="flex items-center gap-2">
        <QAPairButton
          visible={qaPairBtnInfo.visible}
          source={qaPairBtnInfo.source}
          submitted={qaPairBtnInfo.isSubmitted}
          onClick={(source) => {
            if (qaPairBtnInfo.triggerType === 'ModifyOnChat') {
              showModifyOnChat({ message: raw, conversation });
              return;
            }
            trigger(conversation, raw, source);
          }}
        />
        {extraNode}
      </div>
    );
  }

  return extraNode;
};

export const AssistantFooter = (props: AssistantFooterProps) => {
  const { raw, isGalaxy } = props;
  const { isFromOfficial } = raw;
  const tp = useTransAppProductName();

  if (isFromOfficial) {
    return <OfficialFooter {...props} />;
  }

  const msgFromSource = <div className={fromInfo}>{tp('ViewsChat.manualReplyOnClient')}</div>;

  if (isGalaxy) {
    return msgFromSource;
  }

  return <DefaultFooter {...props} extraNode={msgFromSource} />;
};
